import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Chip,
  Box,
} from '@mui/material';
import { FitnessCenter as FitnessCenterIcon } from '@mui/icons-material';
import { useLanguage } from '../../i18n/LanguageContext';
import { TrainingProgram } from '../../services/api/ProgramApiService';

interface ProgramBrowserCardProps {
  program: TrainingProgram;
  onEnroll: (program: TrainingProgram) => void;
}

export const ProgramBrowserCard: React.FC<ProgramBrowserCardProps> = ({ program, onEnroll }) => {
  const { t } = useLanguage();

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
          <FitnessCenterIcon color="primary" />
          <Typography variant="h6">{program.name}</Typography>
        </Box>
        {program.description && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {program.description}
          </Typography>
        )}
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip size="small" label={program.type} variant="outlined" />
          <Chip
            size="small"
            label={`${program.frequency} ${t('programs.workoutsPerWeek')}`}
            variant="outlined"
          />
          {program.duration_weeks && (
            <Chip size="small" label={`${program.duration_weeks}w`} variant="outlined" />
          )}
        </Box>
      </CardContent>
      <CardActions>
        <Button size="small" variant="contained" onClick={() => onEnroll(program)}>
          {t('programs.enroll')}
        </Button>
      </CardActions>
    </Card>
  );
};
